import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe responsável por transformar um CPF.
 */
@Pipe({name: 'cpf'})
export class CpfPipe implements PipeTransform {

    transform(input: string): string {
        return input ? `${input.substr(0, 3)}.${input.substr(3, 3)}.${input.substr(6, 3)}-${input.substr(9, 2)}` : '';
    }
}
